import { Box, OutlinedInput } from '@mui/material';
import Typography from '@mui/material/Typography';
import { inputBox, inputOutlined } from 'app/components/CustomInput/CustomInput.sx';

interface Props {
  title?: string;
  placeholder?: string;
  value?: string;
  handleChange?: (e: any) => void;
  width?: string;
  disabled?: boolean;
  adornment?: any;
  isValid?: boolean;
  rest?: any;
  adornmentStart?: any;
  sx?: any;
  handleFocus?: any;
  handleBlur?: any;
  errorText?: string;
}

const CustomInput = (props: Props) => {
  const {
    title,
    placeholder,
    value,
    disabled,
    handleChange,
    adornment,
    width,
    rest,
    isValid,
    adornmentStart,
    sx,
    handleBlur,
    handleFocus,
    errorText,
  } = props;

  return (
    <Box sx={width !== undefined ? { ...inputBox, width } : inputBox}>
      <Typography sx={{ fontSize: '15px', fontWeight: 400, lineHeight: 1 }}>{title}</Typography>
      <OutlinedInput
        placeholder={placeholder}
        sx={{ ...inputOutlined(isValid), ...sx }}
        value={value}
        disabled={disabled}
        endAdornment={adornment}
        startAdornment={adornmentStart}
        onChange={handleChange}
        inputProps={{ ...rest }}
        error={isValid}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {isValid && <Typography sx={{ color: 'red', fontSize: '14px' }}>{errorText}</Typography>}
    </Box>
  );
};

export default CustomInput;
